import styled, { css } from 'styled-components';

export const Content = styled.select`
  cursor: pointer;
  padding: 7px 4px;
  height: auto;
  position: relative;
  background-color: #fff;
  border-radius: 3px;
  color: #000;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      color: #fff;
    `}
`;
